import { render, staticRenderFns } from "./VacantesLandingPage.vue?vue&type=template&id=0563cb1a&scoped=true"
import script from "./VacantesLandingPage.vue?vue&type=script&lang=js"
export * from "./VacantesLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563cb1a",
  null
  
)

export default component.exports